module.exports = __webpack_public_path__ + "img/top_center.dc405f61.svg";